module.exports = __webpack_public_path__ + "static/media/instagram-mobile-3.10fb5f68.svg";